import { Component, Input, OnInit } from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppSettingsService } from '../../../services/app-settings.service';

@Component({
  selector: 'terra-lp-holding-tabs-nav',
  templateUrl: './lp-holding-tabs-nav.component.html',
  styleUrls: ['./lp-holding-tabs-nav.component.scss']
})
export class LpHoldingTabsNavComponent implements OnInit {
  @Input() originFundId$: Observable<number>;
  @Input() isFunded$: Observable<boolean>;
  @Input() tabPanel: MatTabNavPanel;

  displaySubscribeTab$: Observable<boolean>;

  constructor(private appSettingsService: AppSettingsService) { }

  ngOnInit(): void {
    this.displaySubscribeTab$ = this.isFunded$.pipe(
      take(1),
      map(isFunded => !isFunded && !this.appSettingsService.production )
    );
  }

}
